import { Locale } from '@synergy/models';
import { createSelector } from 'reselect';
import { defaultLocale } from '@synergy/config';

import { AppState } from '../../store/models/app-state';

const getUserLocale = (state: AppState) => state.user.locale;
const getCurrentLocale = (state: AppState) => state.locale;

export const localesSelector = createSelector([getUserLocale, getCurrentLocale], (userLocale, currentLocale) => {
    const orderedLocales = [
        ...(userLocale ? [userLocale] : []),
        ...(currentLocale ? [currentLocale] : []),
        defaultLocale,
        ...Object.values(Locale),
    ];
    // return set of unique locales sorted by priority
    return orderedLocales.filter((item, pos) => orderedLocales.indexOf(item) === pos);
});

export const bestLocaleSelector = createSelector([localesSelector], locales => {
    return locales[0];
});
